import { useHeaderMenuContext } from '@/ebat/contexts/Header/HeaderMenuContext/HeaderMenuContext';

const useHeaderMenuToggle = (
  menuName,
  menuType,
  menuPlacement,
  menuContent,
  menuWidth = null,
) => {
  const {
    isOpen: isMenuOpen,
    handleOpen,
    handleClose,
  } = useHeaderMenuContext();
  const isOpen = isMenuOpen({ name: menuName, type: menuType });

  const handleToggle = (e) => {
    e?.preventDefault();
    e?.stopPropagation();
    if (isOpen) {
      handleClose();
    } else {
      handleOpen(menuName, menuType, menuPlacement, menuContent, menuWidth);
    }
  };

  return {
    isOpen,
    handleToggle,
  };
};

export default useHeaderMenuToggle;
